import Swiper from "swiper/bundle";
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'

export default () => {
    let slider;
    let slideCount;

    slider = document.querySelector(".swiper-testimonials");

    if (slider) {
        slideCount = slider.querySelectorAll('.swiper-slide').length;

        const testimonialsSlider = new Swiper(".swiper-testimonials", {
            initialSlide: Math.ceil(slideCount / 2) - 1,
            spaceBetween: 32,
            centeredSlides: true,
            centeredSlidesBounds: false,
            rewind: true,
            grabCursor: true,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 32,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                },
                1280: {
                    slidesPerView: 2.2,
                    spaceBetween: 32,
                },
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    slider = document.querySelector(".swiper-events");

    if (slider) {
        slideCount = slider.querySelectorAll('.swiper-slide').length;

        const eventsSlider = new Swiper(".swiper-events", {
            initialSlide: Math.ceil(slideCount / 2) - 1,
            spaceBetween: 28,
            centeredSlides: true,
            centeredSlidesBounds: false,
            rewind: true,
            grabCursor: true,
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 1.2,
                    spaceBetween: 32,
                },
                1280: {
                    slidesPerView: 2.5,
                    spaceBetween: 28,
                },
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        let lightbox = new PhotoSwipeLightbox({
            gallery: '.swiper-events',
            children: '.swiper-slide',
            pswpModule: PhotoSwipe,
            showHideOpacity: true,
        })

        lightbox.init()
    }

    slider = document.querySelector(".product-slider");

    if (slider) {
        const thumbnailsSlider = new Swiper(".thumbnails-slider", {
            spaceBetween: 12,
            slidesPerView: 4.5,
            freeMode: true,
            watchSlidesProgress: true,
            grabCursor: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
        const productSlider = new Swiper(".product-slider", {
            spaceBetween: 12,
            loop: true,
            grabCursor: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumbnailsSlider,
            },
        });
    }

    slider = document.querySelector(".categories-slider");

    if (slider) {
        const categoriesSlider = new Swiper(".categories-slider", {
            slidesPerView: "auto",
            spaceBetween: 10,
            grabCursor: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
}
